import { render } from "./Truck.vue?vue&type=template&id=92ad5cc4"
import script from "./Truck.vue?vue&type=script&lang=js"
export * from "./Truck.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/Icons/Truck.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "92ad5cc4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('92ad5cc4', __exports__)) {
    api.reload('92ad5cc4', __exports__)
  }
  
  module.hot.accept("./Truck.vue?vue&type=template&id=92ad5cc4", () => {
    api.rerender('92ad5cc4', render)
  })

}


export default __exports__